/**
 * BHADKO OTT - Curated Channels Data
 * Initial catalog loaded into Persistent Storage (localStorage)
 */

export const DEFAULT_CHANNELS = [
  {
    id: "bhadko-tv",
    name: "Bhadko TV",
    gujaratiName: "ગુજરાતી સમાચાર",
    category: "News",
    language: "Gujarati",
    status: "LIVE", // LIVE | STARTING_SOON | OFFLINE
    isFeatured: true,
    isVerified: true,
    viewers: "12.4K",
    displayOrder: 1,
    description: "Premier 24/7 Gujarati news and analysis. Authentic breaking coverage across all 33 districts of Gujarat.",
    logoColor: "#FF6B00",
    badgeType: "news",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    backupStreamUrl: "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8",
    videoPoster: "news_anchor_live",
    ticker: "રાજ્યમાં આગામી 2 દિવસ ભારે વરસાદની આગાહી ■ વડોદરા, છોટાઉદેપુર, નર્મદા અને ડાંગ જિલ્લામાં ભારે વરસાદની શક્યતા",
    schedule: [
      { time: "07:00", title: "સવારના તાજા સમાચાર", host: "દિલીપ જોશી", isLive: false },
      { time: "08:30", title: "ગુજરાત મુખ્ય સમાચાર", host: "પ્રિયા ત્રિવેદી", isLive: true },
      { time: "10:00", title: "કૃષિ દર્શન વિશેષ", host: "મહેશ પટેલ", isLive: false },
      { time: "12:00", title: "બપોરના ૧૦૦ મોટા સમાચાર", host: "ભાવેશ પંડ્યા", isLive: false },
      { time: "15:00", title: "જિલ્લા ડાયરી", host: "સ્નેહા શાહ", isLive: false },
      { time: "18:00", title: "રાજ્યની વાત", host: "અમિત મહેતા", isLive: false },
      { time: "20:00", title: "મહા ડિબેટ લાઈવ", host: "વિવેક દવે", isLive: false },
      { time: "21:30", title: "ભડકો સ્પેશિયલ પ્રાઈમ", host: "પ્રિયા ત્રિવેદી", isLive: false }
    ],
    about: {
      broadcastStudio: "Ahmedabad Media City, Gujarat",
      network: "BHADKO DIGITAL TV MEDIA",
      resolution: "1080p Full HD • 60 FPS",
      bitrate: "4.8 Mbps H.264 / AAC",
      audio: "Stereo 5.1 Dolby Digital",
      editorialChief: "Rajesh Trivedi"
    }
  },
  {
    id: "gujarat-news-24",
    name: "Gujarat News 24/7",
    gujaratiName: "તાજા સમાચાર",
    category: "News",
    language: "Gujarati",
    status: "LIVE",
    isFeatured: true,
    isVerified: true,
    viewers: "8.7K",
    displayOrder: 2,
    description: "24-hour fast bulletins from every corner of Gujarat. Instant updates, traffic, weather, and business news.",
    logoColor: "#DC2626",
    badgeType: "news24",
    streamUrl: "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8",
    backupStreamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    videoPoster: "gujarat_news_studio",
    ticker: "સૌરાષ્ટ્ર અને ઉત્તર ગુજરાતના જળાશયોમાં નવા નીરની આવક ■ મુખ્યમંત્રીની ઉચ્ચ સ્તરીય બેઠક",
    schedule: [
      { time: "06:00", title: "પ્રભાત દર્શન", host: "કલ્પેશ વ્યાસ", isLive: false },
      { time: "08:00", title: "સુપરફાસ્ટ 50", host: "ઋષિ રાવલ", isLive: false },
      { time: "09:00", title: "સચિવાલય બુલેટિન", host: "અંકિતા પટેલ", isLive: true },
      { time: "12:00", title: "તાજા ન્યૂઝ લાઈવ", host: "મનિષ શાહ", isLive: false }
    ],
    about: {
      broadcastStudio: "Gandhinagar Infocity, Gujarat",
      network: "BHADKO DIGITAL TV MEDIA",
      resolution: "1080p Full HD",
      bitrate: "3.5 Mbps H.264",
      audio: "Stereo AAC",
      editorialChief: "Jayesh Parmar"
    }
  },
  {
    id: "bhadko-sports",
    name: "Bhadko Sports",
    gujaratiName: "રમત ગમત",
    category: "Sports",
    language: "Gujarati",
    status: "LIVE",
    isFeatured: true,
    isVerified: true,
    viewers: "24.1K",
    displayOrder: 3,
    description: "All major sports events, live cricket tournaments, Pro Kabaddi, grassroots athletics, and sports analysis.",
    logoColor: "#0284C7",
    badgeType: "sports",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    backupStreamUrl: "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8",
    videoPoster: "sports_cricket_live",
    ticker: "ગુજરાત પ્રીમિયર લીગ ફાઇનલ મેચ આજે રાત્રે 8 વાગ્યે લાઈવ પ્રસારણ ■ તમામ ટિકિટો હાઉસફુલ",
    schedule: [
      { time: "10:00", title: "ક્રિકેટ વિશ્લેષણ શો", host: "ચેતન શર્મા", isLive: false },
      { time: "14:00", title: "કબડ્ડી મહાસંગ્રામ", host: "સુરેશ દેસાઈ", isLive: false },
      { time: "18:00", title: "સ્પોર્ટ્સ બુલેટિન લાઈવ", host: "રાહુલ પંડિત", isLive: true },
      { time: "20:00", title: "લાઈવ મેચ પ્રસારણ", host: "કોમેન્ટ્રી ટીમ", isLive: false }
    ],
    about: {
      broadcastStudio: "Narendra Modi Stadium Complex, Ahmedabad",
      network: "BHADKO DIGITAL TV MEDIA",
      resolution: "1080p 60fps Ultra Motion",
      bitrate: "5.2 Mbps H.264",
      audio: "5.1 Surround Sound",
      editorialChief: "Sanjay Joshi"
    }
  },
  {
    id: "cinema-gold",
    name: "Cinema Gold",
    gujaratiName: "ચલચિત્ર",
    category: "Movies",
    language: "Gujarati",
    status: "STARTING_SOON",
    isFeatured: true,
    isVerified: true,
    viewers: "5.2K",
    displayOrder: 4,
    description: "Premium Gujarati and Bollywood movies, regional cinema masterpieces, and exclusive film festival premieres.",
    logoColor: "#D97706",
    badgeType: "movies",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    backupStreamUrl: "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8",
    videoPoster: "cinema_gold_movie",
    ticker: "આગામી ચલચિત્ર: છેલ્લો શો (The Last Film Show) બપોરે 2:30 કલાકે શરૂ થશે",
    schedule: [
      { time: "11:30", title: "ગુજરાતી ક્લાસિક હિટ્સ", host: "સિનેમા આર્કાઇવ", isLive: false },
      { time: "14:30", title: "છેલ્લો શો (Chhello Show)", host: "સુપરહિટ મૂવી", isLive: false },
      { time: "17:30", title: "હેલ્લારો (Hellaro)", host: "નેશનલ એવોર્ડ વિનર", isLive: false },
      { time: "21:00", title: "ચાલ જીવી લઈએ (Chaal Jeevi Laiye)", host: "બ્લોકબસ્ટર", isLive: false }
    ],
    about: {
      broadcastStudio: "Film City, Vadodara",
      network: "BHADKO DIGITAL TV MEDIA",
      resolution: "1080p Cinema Scope 2.39:1",
      bitrate: "6.0 Mbps High Profile",
      audio: "Dolby Atmos 7.1 Compatible",
      editorialChief: "Mehul Kumar"
    }
  },
  {
    id: "bhadko-music",
    name: "Bhadko Music",
    gujaratiName: "સંગીત અને ગરબા",
    category: "Music",
    language: "Gujarati",
    status: "LIVE",
    isFeatured: true,
    isVerified: true,
    viewers: "15.8K",
    displayOrder: 5,
    description: "Pop, Gujarati folk, non-stop Navratri Garba, Sugam Sangeet, and live youth music concerts.",
    logoColor: "#8B5CF6",
    badgeType: "music",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    backupStreamUrl: "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8",
    videoPoster: "garba_music_stage",
    ticker: "નવરાત્રી ગરબા ધમાલ લાઈવ શો ■ કિર્તીદાન ગઢવી અને ઓસમાણ મીર સાથે વિશેષ રજૂઆત",
    schedule: [
      { time: "08:00", title: "સુગમ સંગીત પ્રભાતી", host: "શ્યામલ-સૌમિલ", isLive: false },
      { time: "11:00", title: "લોક ડાયરો વિશેષ", host: "માયાભાઈ આહીર", isLive: false },
      { time: "15:00", title: "ટોપ 20 ગુજરાતી બીટ્સ", host: "વીજે પૂજા", isLive: true },
      { time: "20:00", title: "દાંડિયા રાસ મહાઉત્સવ", host: "લાઈવ કલાકારો", isLive: false }
    ],
    about: {
      broadcastStudio: "Rajkot Cultural Studio, Gujarat",
      network: "BHADKO DIGITAL TV MEDIA",
      resolution: "1080p 60fps Hi-Fi",
      bitrate: "4.5 Mbps H.264",
      audio: "Lossless Audio Master 320kbps",
      editorialChief: "Hemant Chauhan"
    }
  },
  {
    id: "bhadko-bhakti",
    name: "Bhadko Bhakti",
    gujaratiName: "ભક્તિ અને સત્સંગ",
    category: "Devotional",
    language: "Gujarati",
    status: "LIVE",
    isFeatured: false,
    isVerified: true,
    viewers: "31.2K",
    displayOrder: 6,
    description: "Live Aarti and Darshan from Somnath, Dwarkadhish, Ambaji, Pavagadh, and daily Santvani satsang.",
    logoColor: "#F59E0B",
    badgeType: "bhakti",
    streamUrl: "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8",
    backupStreamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    videoPoster: "temple_darshan_live",
    ticker: "સોમનાથ મહાદેવ મંદિરથી સીધું પ્રસારણ ■ સાંજની મહાઆરતી 7:00 કલાકે દર્શન",
    schedule: [
      { time: "06:00", title: "મંગળા આરતી દર્શન", host: "દ્વારકાધીશ મંદિર", isLive: false },
      { time: "07:30", title: "પ્રભાતિયા અને કીર્તન", host: "ભક્તિ સંગીત", isLive: false },
      { time: "09:00", title: "શ્રીમદ્ ભાગવત કથા", host: "પૂજ્ય સંતશ્રી", isLive: true },
      { time: "19:00", title: "સંધ્યા દીપમાળા આરતી", host: "સોમનાથ મંદિર", isLive: false }
    ],
    about: {
      broadcastStudio: "Somnath Spiritual Media Unit",
      network: "BHADKO DIGITAL TV MEDIA",
      resolution: "1080p Crystal Darshan",
      bitrate: "4.0 Mbps",
      audio: "Pristine Temple Audio",
      editorialChief: "Shastri Hariprasad"
    }
  },
  {
    id: "dd-girnar",
    name: "DD Girnar",
    gujaratiName: "દૂરદર્શન ગિરનાર",
    category: "News",
    language: "Gujarati",
    status: "LIVE",
    isFeatured: false,
    isVerified: true,
    viewers: "9.3K",
    displayOrder: 7,
    description: "Official public broadcast channel presenting regional heritage, agriculture guidance, and authentic news.",
    logoColor: "#10B981",
    badgeType: "dd",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    backupStreamUrl: "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8",
    videoPoster: "dd_girnar_studio",
    ticker: "ગ્રામીણ ખેડૂતો માટે ટેકાના ભાવ જાહેર ■ હવામાન ખાતાની નવીનતમ માર્ગદર્શિકા",
    schedule: [
      { time: "07:00", title: "ગામનો ચોરો", host: "દૂરદર્શન ટીમ", isLive: false },
      { time: "11:00", title: "કૃષિ વિજ્ઞાન", host: "ડો. સોલંકી", isLive: false },
      { time: "17:30", title: "ગિરનાર સમાચાર", host: "દૂરદર્શન ન્યૂઝરૂમ", isLive: true },
      { time: "20:30", title: "ગુજરાત દર્શન", host: "ડોક્યુમેન્ટ્રી", isLive: false }
    ],
    about: {
      broadcastStudio: "Doordarshan Kendra, Thaltej, Ahmedabad",
      network: "Prasar Bharati / BHADKO Relay",
      resolution: "1080p Broadcast Grade",
      bitrate: "4.2 Mbps",
      audio: "Stereo National Standard",
      editorialChief: "Director Doordarshan"
    }
  },
  {
    id: "gyan-gujarati",
    name: "Gyan Gujarati",
    gujaratiName: "વિદ્યા અને કારકિર્દી",
    category: "Education",
    language: "Gujarati",
    status: "LIVE",
    isFeatured: false,
    isVerified: false,
    viewers: "4.1K",
    displayOrder: 8,
    description: "Educational lectures, GPSC, UPSC preparation, career development, and board exam revision tutorials.",
    logoColor: "#6366F1",
    badgeType: "education",
    streamUrl: "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8",
    backupStreamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    videoPoster: "education_lecture_live",
    ticker: "GPSC ક્લાસ 1-2 ની પરીક્ષાનું વિશ્લેષણ અને મોડેલ પેપર સોલ્યુશન લાઈવ ક્લાસ",
    schedule: [
      { time: "09:00", title: "ગુજરાતી વ્યાકરણ અને સાહિત્ય", host: "પ્રો. શાસ્ત્રી", isLive: false },
      { time: "11:30", title: "ભારતનું બંધારણ", host: "એડવોકેટ વ્યાસ", isLive: false },
      { time: "14:00", title: "ગણિત અને રિઝનિંગ શોર્ટકટ્સ", host: "પટેલ સર", isLive: true },
      { time: "19:00", title: "કરંટ અફેર્સ ડેઇલી ડોઝ", host: "જ્ઞાન ફેકલ્ટી", isLive: false }
    ],
    about: {
      broadcastStudio: "Education Hub, Gandhinagar",
      network: "BHADKO DIGITAL TV MEDIA",
      resolution: "1080p Clear Board View",
      bitrate: "3.2 Mbps",
      audio: "Vocal Clarity Enhanced",
      editorialChief: "Prof. Arvind Dave"
    }
  },
  {
    id: "bhadko-comedy",
    name: "Bhadko Comedy",
    gujaratiName: "હાસ્ય દરબાર",
    category: "Entertainment",
    language: "Gujarati",
    status: "LIVE",
    isFeatured: true,
    isVerified: true,
    viewers: "18.6K",
    displayOrder: 9,
    description: "Legendary Gujarati Natak, hilarious skits, stand-up comedy specials, and family comedy series.",
    logoColor: "#EC4899",
    badgeType: "comedy",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    backupStreamUrl: "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8",
    videoPoster: "gujarati_natak_stage",
    ticker: "સિદ્ધાર્થ રાંદેરિયાનું સુપરહિટ નાટક 'ગુજ્જુભાઈ' રાત્રે 9 કલાકે ખાસ પ્રસારણ",
    schedule: [
      { time: "12:00", title: "હાસ્યના હોંકારા", host: "શાહબુદ્દીન રાઠોડ", isLive: false },
      { time: "15:00", title: "ધીરુભાઈ સરવૈયા સ્પેશિયલ", host: "લોક હાસ્ય કલાકાર", isLive: false },
      { time: "18:30", title: "કોમેડી કિંગ્સ લાઈવ", host: "હસમુખ મહેતા", isLive: true },
      { time: "21:00", title: "ગુજ્જુભાઈ મહા નાટક", host: "સિદ્ધાર્થ રાંદેરિયા", isLive: false }
    ],
    about: {
      broadcastStudio: "Bhadko Studios, Surat, Gujarat",
      network: "BHADKO DIGITAL TV MEDIA",
      resolution: "1080p 60fps Theater Master",
      bitrate: "4.8 Mbps",
      audio: "Multi-track Audience Audio",
      editorialChief: "Siddharth Randeria"
    }
  },
  {
    id: "sandesh-live",
    name: "Sandesh Samachar",
    gujaratiName: "સંદેશ લાઈવ",
    category: "News",
    language: "Gujarati",
    status: "LIVE",
    isFeatured: false,
    isVerified: true,
    viewers: "11.5K",
    displayOrder: 10,
    description: "Comprehensive reporting, stock market pulse, regional developments, and in-depth investigative journalism.",
    logoColor: "#EA580C",
    badgeType: "sandesh",
    streamUrl: "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8",
    backupStreamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    videoPoster: "sandesh_news_room",
    ticker: "શેરબજારમાં તેજીનો માહોલ ■ સેન્સેક્સ 80,000 ને પાર, રોકાણકારોમાં ઉત્સાહ",
    schedule: [
      { time: "08:00", title: "સંદેશ મોર્નિંગ હેડલાઇન્સ", host: "અજય સોની", isLive: false },
      { time: "13:00", title: "બજાર મંચ", host: "હર્ષ શાહ", isLive: false },
      { time: "19:00", title: "સંદેશ પ્રાઈમ ટાઈમ", host: "રોહિત પટેલ", isLive: true }
    ],
    about: {
      broadcastStudio: "Bodakdev, Ahmedabad",
      network: "Sandesh Media / BHADKO Partner",
      resolution: "1080p Studio HD",
      bitrate: "4.1 Mbps",
      audio: "Crisp Stereo",
      editorialChief: "Parthiv Patel"
    }
  },
  {
    id: "rangilo-gujarat",
    name: "Rangilo Gujarat",
    gujaratiName: "સંસ્કૃતિ અને પ્રવાસન",
    category: "Entertainment",
    language: "Gujarati",
    status: "OFFLINE",
    isFeatured: false,
    isVerified: false,
    viewers: "0",
    displayOrder: 11,
    description: "Travel shows across Saurashtra, Kutch, and Gir forest. Traditional culinary recipes and handicraft showcases.",
    logoColor: "#4B5563",
    badgeType: "travel",
    streamUrl: "https://invalid-offline-stream.bhadko.tv/live.m3u8",
    backupStreamUrl: "",
    videoPoster: "kutch_desert_sunset",
    ticker: "ચેનલ હાલમાં ઓફલાઇન છે. આગામી પ્રસારણ આવતીકાલે સવારે 06:00 કલાકે શરૂ થશે.",
    schedule: [
      { time: "06:00", title: "રણ ઉત્સવ કચ્છ દર્શન", host: "પ્રવાસ ટીમ", isLive: false },
      { time: "12:00", title: "ગીર જંગલ સફારી ડાયરી", host: "વન્યજીવ નિષ્ણાત", isLive: false }
    ],
    about: {
      broadcastStudio: "Bhuj Kutch Heritage Studio",
      network: "BHADKO DIGITAL TV MEDIA",
      resolution: "1080p 4K Nature Reel",
      bitrate: "Off-air",
      audio: "Ambience Recorded",
      editorialChief: "Ketan Dholakia"
    }
  },
  {
    id: "bhadko-kids",
    name: "Bhadko Bal Bhavan",
    gujaratiName: "બાળ ભવન",
    category: "Education",
    language: "Gujarati",
    status: "LIVE",
    isFeatured: false,
    isVerified: true,
    viewers: "6.9K",
    displayOrder: 12,
    description: "Gujarati animated moral tales (Panchatantra, Akbar Birbal), fun nursery rhymes, science experiments for kids.",
    logoColor: "#14B8A6",
    badgeType: "kids",
    streamUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    backupStreamUrl: "https://cph-p2p-msl.akamaized.net/hls/live/2000341/test/master.m3u8",
    videoPoster: "cartoon_kids_animation",
    ticker: "બપોરે 4 વાગ્યે: અકબર બીરબલની ચતુર વાર્તાઓ - ખાસ એનિમેશન પ્રસારણ",
    schedule: [
      { time: "08:00", title: "બાલગીતો અને જોડકણાં", host: "મીકુ અને ચીકુ", isLive: false },
      { time: "10:30", title: "પંચતંત્રની બોધકથાઓ", host: "દાદીમા ની વાતો", isLive: false },
      { time: "16:00", title: "અકબર બીરબલ કાર્ટૂન", host: "એનિમેશન સ્ટુડિયો", isLive: true }
    ],
    about: {
      broadcastStudio: "Animation Lab, Vadodara",
      network: "BHADKO DIGITAL TV MEDIA",
      resolution: "1080p 60fps Cartoon Vivid",
      bitrate: "4.0 Mbps",
      audio: "Family Safe Stereo",
      editorialChief: "Neha Joshi"
    }
  }
];

export const CATEGORIES = [
  { id: "all", labelEn: "All", labelGu: "બધા", labelHi: "सभी", icon: "grid" },
  { id: "News", labelEn: "News", labelGu: "સમાચાર", labelHi: "समाचार", icon: "newspaper" },
  { id: "Sports", labelEn: "Sports", labelGu: "રમત ગમત", labelHi: "खेल", icon: "trophy" },
  { id: "Entertainment", labelEn: "Entertainment", labelGu: "મનોરંજન", labelHi: "मनोरंजन", icon: "film" },
  { id: "Devotional", labelEn: "Devotional", labelGu: "ભક્તિ", labelHi: "भक्ति", icon: "om" },
  { id: "Music", labelEn: "Music", labelGu: "સંગીત", labelHi: "संगीत", icon: "music" },
  { id: "Education", labelEn: "Education", labelGu: "શિક્ષણ", labelHi: "शिक्षा", icon: "book" },
  { id: "Movies", labelEn: "Movies", labelGu: "ચલચિત્ર", labelHi: "फ़िल्में", icon: "clapper" }
];
